import React from "react";
import { FormControl, FormHelperText, FormLabel, Input, useColorModeValue } from "@chakra-ui/react";

/**
 * Labeled Chakra input with optional helper text, shared across the rate forms.
 * When `children` is provided it replaces the default Input (used for Select).
 * @param {Object} props - field props
 * @param {string} props.label - field label
 * @param {string} [props.value] - input value
 * @param {Function} [props.onChange] - receives the raw next value
 * @param {string} [props.helper] - helper text below the field
 * @param {boolean} [props.isRequired] - marks the field as required
 * @param {React.ReactNode} [props.children] - custom control replacing the Input
 * @returns {React.ReactElement}
 */
function RateField({ label, value, onChange, helper, isRequired, children, ...rest }) {
    const labelColor = useColorModeValue("secondaryGray.900", "white");
    const helperColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");

    return (
        <FormControl isRequired={isRequired}>
            <FormLabel fontSize="sm" fontWeight="600" color={labelColor} mb="4px">{label}</FormLabel>
            {children || (
                <Input value={value} onChange={(e) => onChange(e.target.value)} borderRadius="12px" {...rest} />
            )}
            {helper && <FormHelperText fontSize="xs" color={helperColor}>{helper}</FormHelperText>}
        </FormControl>
    );
}

export default RateField;
